/* Nordri mega menu: the carousels in the ember panels (arrows, dots, turning every 4 seconds
   while the drop-down is open and the mouse is not on them) and the "Live preview" style
   (the right panel's card shows the item under the mouse). */
(() => {
  if (window.__nordriMenu) return;
  window.__nordriMenu = true;

  const visible = (el) => el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';

  // A carousel does not turn by itself while the phone menu is being touched or scrolled (and for
  // a few seconds after): turning it then broke a fast finger scroll, which jumped down the menu.
  let touchedAt = 0;
  const busy = () => performance.now() - touchedAt < 4000;
  const touched = (e) => {
    if (e.target instanceof Element && e.target.closest('.nordri-drawer .menu-drawer')) touchedAt = performance.now();
  };
  ['touchstart', 'touchmove', 'wheel'].forEach((t) => document.addEventListener(t, touched, { passive: true, capture: true }));
  document.addEventListener('scroll', touched, { passive: true, capture: true });

  function setup(car) {
    if (car.dataset.ready) return;
    car.dataset.ready = '1';
    const track = car.querySelector('.nmm-car__track');
    const items = [...track.children];
    if (!items.length) return;
    const dotsBox = car.querySelector('.nmm-car__dots');
    let i = 0;
    const perView = () => Math.max(1, Math.round(track.clientWidth / (items[0].getBoundingClientRect().width || 1)));
    const last = () => Math.max(0, items.length - perView());
    const dots = () => (dotsBox ? [...dotsBox.children] : []);
    const drawDots = () => {
      if (!dotsBox) return;
      const n = last() + 1;
      if (dotsBox.children.length !== n) dotsBox.innerHTML = '<i></i>'.repeat(n);
      dots().forEach((d, j) => d.classList.toggle('is-on', j === i));
    };
    const go = (to) => {
      const max = last();
      i = to > max ? 0 : to < 0 ? max : to;
      track.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
      drawDots();
    };
    car.querySelectorAll('[data-dir]').forEach((b) => b.addEventListener('click', (e) => {
      e.preventDefault();
      go(i + Number(b.dataset.dir));
    }));
    let hover = false;
    car.addEventListener('pointerenter', () => (hover = true));
    car.addEventListener('pointerleave', () => (hover = false));
    drawDots();
    if (dotsBox && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setInterval(() => {
        if (!hover && visible(car) && document.visibilityState === 'visible' && !busy()) go(i + 1);
      }, 4000);
    }
  }

  const init = () => document.querySelectorAll('[data-nm-car]').forEach(setup);
  init();
  let queued = 0;
  new MutationObserver(() => {
    if (queued) return;
    queued = requestAnimationFrame(() => {
      queued = 0;
      init();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Phone menu: it opens right under the header, so the header (and its button that turns into a
  // cross) stays in view. The header's height is measured each time the menu opens.
  const placeDrawer = (drawer) => {
    const header = drawer.closest('#header-component, header-component, .header') || document.querySelector('#header-component');
    const bottom = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    drawer.style.setProperty('--nmd-top', `${bottom}px`);
  };
  // Opening and closing are handled here, on a fixed timer: the theme waits for the slide to
  // finish before it marks the menu closed, and a quick tap after closing could land before that,
  // leaving the button showing the cross over a menu that stayed shut.
  const timers = new WeakMap();
  // Opening the menu locks the page, which unsticks the header once the page has been scrolled
  // (it would scroll away with the page). So the header is pinned where it is until the menu closes.
  const pinHeader = (on) => {
    const root = document.documentElement;
    const header = document.querySelector('#header-component');
    if (!header) return;
    if (on && window.scrollY > 0) {
      root.style.setProperty('--nmd-head-top', `${Math.max(0, Math.round(header.getBoundingClientRect().top))}px`);
      root.style.setProperty('--nmd-head-h', `${Math.round(header.getBoundingClientRect().height)}px`);
      root.classList.add('nmd-fixhead');
    } else {
      root.classList.remove('nmd-fixhead');
    }
  };
  // Phones (Safari and Chrome) ignore the theme's page lock for finger scrolling: the page behind
  // the menu scrolled along, the browser bars came and went and the menu jumped. So the page itself
  // is held in place while the menu is open and put back where it was when it closes.
  let lockY = null;
  const holdPage = (on) => {
    const s = document.body.style;
    if (on) {
      if (lockY !== null) return;
      lockY = window.scrollY;
      Object.assign(s, { position: 'fixed', top: `-${lockY}px`, left: '0', right: '0', width: '100%' });
    } else if (lockY !== null) {
      Object.assign(s, { position: '', top: '', left: '', right: '', width: '' });
      window.scrollTo({ top: lockY, behavior: 'instant' });
      lockY = null;
    }
  };
  const openNav = (details) => {
    const hd = details.closest('.nordri-drawer');
    clearTimeout(timers.get(details));
    pinHeader(true);
    holdPage(true);
    placeDrawer(hd);
    details.open = true;
    details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    // let the browser draw the closed panel first, so it slides in
    void details.querySelector('.menu-drawer')?.offsetWidth;
    details.classList.add('menu-open');
  };
  const closeNav = (details) => {
    details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    details.classList.remove('menu-open');
    clearTimeout(timers.get(details));
    timers.set(details, setTimeout(() => {
      if (!details.classList.contains('menu-open')) {
        details.open = false;
        pinHeader(false);
        holdPage(false);
      }
    }, 380));
  };
  document.addEventListener(
    'click',
    (e) => {
      const t = e.target.closest && e.target.closest('.nordri-drawer summary, .nordri-drawer .menu-drawer__backdrop');
      if (!t) return;
      const details = t.closest('details');
      if (!details) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (t.matches('summary') && !details.classList.contains('menu-open')) openNav(details);
      else closeNav(details);
    },
    true
  );
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.nordri-drawer details.menu-open').forEach(closeNav);
  });
  window.addEventListener('resize', () => document.querySelectorAll('.nordri-drawer').forEach(placeDrawer));
  document.addEventListener(
    'toggle',
    (e) => {
      const d = e.target;
      if (d instanceof Element && d.matches('.nordri-drawer details') && d.open) placeDrawer(d.closest('.nordri-drawer'));
    },
    true
  );

  // Items open in place in the same panel, one at a time
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('[data-nmdm-toggle]');
    if (!btn) return;
    const item = btn.closest('.nmdm__item');
    const open = !item.classList.contains('is-open');
    item.parentElement.querySelectorAll(':scope > .nmdm__item.is-open').forEach((x) => {
      if (x !== item) {
        x.classList.remove('is-open');
        x.querySelector('[data-nmdm-toggle]')?.setAttribute('aria-expanded', 'false');
      }
    });
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', String(open));
  });

  // While the menu is open, scrolling it down tucks the announcement bar away (as on the home
  // page) and scrolling back to its top brings it back; the menu follows the header. The page
  // itself is locked while the menu is open, so the bar is slid up rather than scrolled away.
  const follow = (drawer) => {
    const t0 = performance.now();
    const step = () => {
      placeDrawer(drawer);
      if (performance.now() - t0 < 450) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  const tuck = (drawer, on) => {
    const root = document.documentElement;
    if (root.classList.contains('nmd-tucked') === on) return;
    const ann = document.querySelector('.ann-marquee')?.closest('.shopify-section');
    if (!ann) return;
    root.style.setProperty('--nmd-ann-h', `${ann.offsetHeight}px`);
    root.classList.toggle('nmd-tucked', on);
    if (drawer) follow(drawer);
  };
  // The bar moves only once the scrolling has stopped: moving it (and the menu with it) in the
  // middle of a fast finger scroll made phones lose their place and jump down the menu.
  let tuckTimer = 0;
  document.addEventListener(
    'scroll',
    (e) => {
      const panel = e.target;
      if (!(panel instanceof Element) || !panel.matches('.nordri-drawer .menu-drawer')) return;
      if ((lockY ?? window.scrollY) > 2) return; // the bar is already out of view
      clearTimeout(tuckTimer);
      tuckTimer = setTimeout(() => tuck(panel.closest('.nordri-drawer'), panel.scrollTop > 8), 180);
    },
    true
  );
  document.addEventListener(
    'toggle',
    (e) => {
      const d = e.target;
      if (d instanceof Element && d.matches('.nordri-drawer details') && !d.open && !d.parentElement.closest('.nordri-drawer details')) {
        tuck(null, false);
        // closed some other way (a link, the theme): let the page go too
        pinHeader(false);
        holdPage(false);
      }
    },
    true
  );

  // Live preview: the item under the mouse shows in the right panel's card
  document.addEventListener('pointerover', (e) => {
    const a = e.target.closest && e.target.closest('.nmm--preview .nmm__a');
    if (!a) return;
    const nm = a.closest('.nmm');
    const card = nm.querySelector('.nmm__side--right [data-nm-card]');
    nm.querySelectorAll('.nmm__a.is-hot').forEach((x) => x !== a && x.classList.remove('is-hot'));
    a.classList.add('is-hot');
    if (!card) return;
    const img = card.querySelector('img');
    if (img && a.dataset.nmImg && img.getAttribute('src') !== a.dataset.nmImg) {
      img.removeAttribute('srcset');
      img.src = a.dataset.nmImg;
      img.animate && img.animate([{ opacity: 0.2 }, { opacity: 1 }], { duration: 300, easing: 'ease-out' });
    }
    const t = card.querySelector('[data-nm-card-title]');
    if (t) t.textContent = a.textContent.trim();
    card.href = a.href;
  });
})();
